export default "__VITE_ASSET__CORPd_DA__"